/**
 * Represents a character facial expression.
 *
 * Each expression has a unique identifier and a display name that describes
 * the emotional state it represents. These expressions are used to control
 * the character's facial animations in the avatar system.
 *
 * @property {number} id - Unique identifier for the expression
 * @property {string} value - Human-readable name of the expression
 */
export type Expression = {
  id: number;
  value: string;
};

/**
 * Collection of available facial expressions for character avatars.
 *
 * This array defines all the standard expressions that can be applied to
 * character avatars in the system. Each expression represents a different
 * emotional state that affects how the character's face is rendered.
 *
 * The expressions range from positive emotions (Love it, Ecstatic, Pleased)
 * to negative emotions (Sad, Raging) and neutral states (Stoic).
 *
 * These expressions are used by the character rendering engine to determine
 * which facial animation to display.
 *
 */
export const expressions: Expression[] = [
  { id: 1, value: 'Love it' }, // Positive, affectionate expression
  { id: 2, value: 'Ecstatic' }, // Extremely happy, excited expression
  { id: 3, value: 'Sad' }, // Unhappy, sorrowful expression
  { id: 4, value: 'Pleased' }, // Content, satisfied expression
  { id: 5, value: 'Raging' }, // Angry, furious expression
  { id: 6, value: 'Stoic' }, // Neutral, emotionless expression
];
